import { isUndefined } from 'lodash-es';

import { ChartOverlaysBorder } from '../../../core/components/overlays/ChartOverlaysBorder.js';
import { useHistogramAnnotationsConfig } from '../../hooks/useHistogramAnnotationsConfig.js';
import { useHistogramYScales } from '../../hooks/useHistogramYScales.js';

export const HistogramChartOverlaysBorder = () => {
  const [leftScale, rightScale] = useHistogramYScales();
  const { tracks } = useHistogramAnnotationsConfig();
  const visibleTracksCount = tracks.filter((track) => !track.hidden).length;

  return (
    <ChartOverlaysBorder
      left={!isUndefined(leftScale)}
      right={!isUndefined(rightScale)}
      bottom
      topSeparator={visibleTracksCount > 1}
    />
  );
};
